package com.essntl.features.price.data.supabase.proposalserviceprice

import com.essntl.features.price.data.supabase.supplierserviceprice.SupplierServicePriceDto
import com.essntl.features.price.domain.model.proposalserviceprice.ProposalServicePriceModel
import com.essntl.features.proposal.data.supabase.proposalservice.ProposalServiceDto
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ProposalServicePriceDto(
    val id: String,
    @SerialName("proposal_service_id_data")
    val proposalService: ProposalServiceDto,
    @SerialName("supplier_service_price_id_data")
    val supplierServicePriceDto: SupplierServicePriceDto,
    val quantity: Double,
    val explanation: String,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("updated_at")
    val updatedAt: String,
    val total: Double?,
    @SerialName("is_selected")
    val isSelected: Boolean?,
    val visibility: String?,
    @SerialName("updated_by")
    val updatedBy: String?,
) {
    fun toModel() = ProposalServicePriceModel(
        id = id,
        proposalService = proposalService.toModel(),
        supplierServicePrice = supplierServicePriceDto.toModel(),
        quantity = quantity,
        explanation = explanation,
        createdAt = createdAt,
        updatedAt = updatedAt,
        total = total,
        isSelected = isSelected,
        visibility = when (visibility) {
            "HIDDEN" -> ProposalServicePriceModel.Visibility.Hidden
            "OPTION" -> ProposalServicePriceModel.Visibility.Option
            "ONLY_OPTION" -> ProposalServicePriceModel.Visibility.OnlyOption
            else -> ProposalServicePriceModel.Visibility.Hidden
        },
        updatedBy = updatedBy,
    )

    companion object {
        const val COLUMNS_VALUE =
            "*, proposal_service_id_data:proposal_service_id(${ProposalServiceDto.COLUMNS_VALUE}), " +
                "supplier_service_price_id_data:supplier_service_price_id(${SupplierServicePriceDto.COLUMNS_VALUE})"

        fun getColumns() =
            Columns.raw(COLUMNS_VALUE)
    }
}

internal fun ProposalServicePriceModel.Visibility.toDto() =
    when (this) {
        ProposalServicePriceModel.Visibility.Hidden -> "HIDDEN"
        ProposalServicePriceModel.Visibility.Option -> "OPTION"
        ProposalServicePriceModel.Visibility.OnlyOption -> "ONLY_OPTION"
    }